/**
 * File related apis
 */

import { CDA_FILE_TYPE, PDF_FILE_TYPE, REPORT_FILE_TYPE, DEVICE_CSV_FILE_TYPE } from '@/config';
import { uploadCda, getCdaDocById } from '@/api/cdaApi';
import { uploadPdf, getPdfById } from '@/api/pdfApi';
import { getReportById } from '@/api/reportApi';
import { uploadBloodPressureDeviceCsv } from '@/api/deviceApi';
import store from '@/store/index';



/**
 * Uploads cda to database
 * upload success reponse from server: {'message' : 'cdaUploadedMessage', 'id' : $idCda}
 * @param {object} formData multipart form data, contains cda in xml format
 * @returns promise
 */
export function uploadFile(fileType, formData) {
  let result = null;
  if (fileType === CDA_FILE_TYPE) {
    result =  uploadCda(formData);
  } else if (fileType === PDF_FILE_TYPE) {
    result =  uploadPdf(formData);
  } else if (fileType === DEVICE_CSV_FILE_TYPE) {
    result =  uploadBloodPressureDeviceCsv(formData);
  } else {
    // alert('fileType is none existent -  see console trace for info');
    console.trace();
  }
  if(result.csrf)
    store.dispatch('login/csrf',result.csrf)
  return result;
};

/**
 * Retrieves cda as a document for viewing
 * request success reponse from server: {'message' : 'replyCdaMessage', 'id' : $idCda, 'text': $cdaDoc}
 * @param {integer} id id of cda to request
 * @returns promise
 */
export function getFileById(fileType, id) {
  if (fileType === CDA_FILE_TYPE) {
    return getCdaDocById(id);
  } else if (fileType === PDF_FILE_TYPE) {
    return getPdfById(id);
  } else if (fileType === REPORT_FILE_TYPE) { 
    return getReportById(id);
  }
  return null;
};
